export const blockIconsPhotoandimageTimerNew = (
	<span className='material-symbols-outlined'>timer</span>
);
